module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "d-show-only-checkbox",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.isShowOnlySubjectsWithoutTeacher = !_vm.isShowOnlySubjectsWithoutTeacher
      }
    }
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Vis kun fag uten underviser")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isShowOnlySubjectsWithoutTeacher),
      expression: "isShowOnlySubjectsWithoutTeacher"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isShowOnlySubjectsWithoutTeacher) ? _vm._i(_vm.isShowOnlySubjectsWithoutTeacher, null) > -1 : (_vm.isShowOnlySubjectsWithoutTeacher)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isShowOnlySubjectsWithoutTeacher,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isShowOnlySubjectsWithoutTeacher = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isShowOnlySubjectsWithoutTeacher = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isShowOnlySubjectsWithoutTeacher = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "doTable__items text-dark"
  }, [(_vm.calendarsWithProps.length === 0) ? _c('h2', {
    staticClass: "text-explainer"
  }, [_vm._v("Ingen klasser opprettet")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.calendarsWithProps), function(calendar) {
    return _c('li', {
      key: calendar.id,
      staticClass: "doTable__klass"
    }, [_c('div', {
      staticClass: "doTable__klass__header"
    }, [_c('div', [_vm._v(_vm._s(calendar.name))]), _vm._v(" "), _c('div', [_c('button', {
      staticClass: "do-bttn",
      on: {
        "click": function($event) {
          return _vm.setIsCreate(calendar)
        }
      }
    }, [_vm._v("Opprett fag i klassen")])])]), _vm._v(" "), _c('ul', {
      staticClass: "subjects"
    }, [(calendar.v_subjects.length < 1) ? _c('h4', {
      staticClass: "text-explainer"
    }, [_vm._v("Ingen fag opprettet")]) : _vm._e(), _vm._v(" "), _vm._l((calendar.v_subjects), function(subject) {
      return (_vm.isShowOnlySubjectsWithoutTeacher ? !subject.v_has_teacher : true) ? _c('li', {
        directives: [{
          name: "tippy",
          rawName: "v-tippy",
          value: ({
            arrow: true,
            onShow: function () { return subject.v_has_teacher; }
          }),
          expression: "{\n                  arrow: true,\n                  onShow: () => subject.v_has_teacher\n                }"
        }],
        key: subject.id,
        staticClass: "subjects_subject",
        class: [{
          'subject--has-user': subject.v_has_teacher
        }, {
          'subject--has-room': subject.v_has_room
        }],
        style: ({
          'background': subject.color
        }),
        attrs: {
          "content": subject.v_teacher_names
        },
        on: {
          "click": function($event) {
            return _vm.setEditSubject(subject)
          }
        }
      }, [_vm._v("\n          " + _vm._s(subject.name) + " (" + _vm._s(subject.hours) + ")\n        ")]) : _vm._e()
    })], 2)])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f43488ea!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Arbeidsplan/ArbeidsplanSubjects.vue
// module id = 2165
// module chunks = 1